<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@/components/ui/alert-dialog/index';

defineProps<{
    open: boolean;
    singular: string;
}>();

const emit = defineEmits<{
    (e: 'update:open', value: boolean): void;
    (e: 'confirm'): void;
}>();

const { t } = useI18n();

function handleOpenChange(value: boolean) {
    emit('update:open', value);
}

function handleConfirm() {
    emit('confirm');
    emit('update:open', false);
}
</script>

<template>
    <AlertDialog :open="open" @update:open="handleOpenChange">
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{ t('crud.delete_confirm_title', { singular }) }}</AlertDialogTitle>
                <AlertDialogDescription>
                    {{ t('crud.delete_confirm_description', { singular: singular.toLowerCase() }) }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{ t('crud.cancel') }}</AlertDialogCancel>
                <AlertDialogAction @click="handleConfirm">
                    {{ t('crud.delete') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
